import {
  LOAD_IMAGES,
  ADD_IMAGE,
  LOAD_IMAGES_BY_BOOK_ID,
  DELETE_IMAGES,
  DELETE_IMAGE,
} from '../../action-types/entities/images';
import { generateId } from '../../helpers/index';

export const STATE_KEY = 'images';

export const images = (state = {
  byId: {},
  allIds: [],
}, action) => {
  switch (action.type) {
    case LOAD_IMAGES: {
      return action.images.slice(0);
    }

    case LOAD_IMAGES_BY_BOOK_ID: {
      return action.bookState;
    }
    case ADD_IMAGE: {
      const byIdNumber = generateId(state.allIds);
      action.image.id = byIdNumber;
      return {
        byId: {
          ...state.byId,
          [byIdNumber]: action.image,
        },
        allIds: [...state.allIds, byIdNumber],
      };
    }

    case DELETE_IMAGE: {
      return [];
    }

    case DELETE_IMAGES: {
      return {
        byId: {},
        allIds: [],
      };
    }

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/redux/reducers/entities/images.js